import axios from 'axios'
import api from '@/api'

const data = {
  data: {},
  default: '',
}

const ebsContentTags = {
  state: JSON.parse(JSON.stringify(data)),
  getters: {
    getEbsContentTags: state => {
      return state.data
    },
  },
  mutations: {
    EBS_CONTENT_TAGS_GET (state, payload) {
      state.data = JSON.parse(JSON.stringify(payload))
      state.default = JSON.parse(JSON.stringify(payload))
    },
  },
  actions: {
    ebsContentTagsGet ({ commit }, data) {
      const enrolmentId = data.enrolmentId
      const token = data.token

      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: `${ api.learningactivities }/content-tags-values/${enrolmentId}`,
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        }).then(response => {
          commit('EBS_CONTENT_TAGS_GET', response.data.tags)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ebsContentTagsClear ({ commit }) {
      commit('EBS_CONTENT_TAGS_GET', {})
    },
  }
}

export default ebsContentTags
